import Vue from 'vue';
import Vuex from 'vuex';

import app from 'store/app';
import meta from 'store/meta';
import auth from 'store/auth';
import home from 'store/home';
import questions from 'store/questions';
import answers from 'store/answers';
import profile from 'store/profile';
import forms from 'store/forms';
import sidebar from 'store/sidebar';
import appointment from 'store/appointment';
import messaging from 'store/messaging';

import contentful from 'store/contentful';

// Provider
import provider from 'store/provider';

Vue.use(Vuex);

const store = new Vuex.Store({ // eslint-disable-line import/no-named-as-default-member
  modules: {
    app,
    meta,
    auth,
    home,
    forms,
    provider,
    questions,
    sidebar,
    messaging,
    answers,
    profile,
    appointment,
    contentful,
  },
});

export default store;



// WEBPACK FOOTER //
// ./client/store/index.js